import responsive from '../../../../../generic/layout/responsive';
import { ImpactChartContextProvider } from './context';
import { NetImpactChartMain } from './main';
import { NetImpactChartProps } from './types';

function Wrapped(props: NetImpactChartProps) {
  const width = props.width || 900;
  return <NetImpactChartPlain {...{ ...props, width }} />;
}

interface PlainNetImpactChartProps extends NetImpactChartProps {
  width?: number;
}

export function NetImpactChartPlain(props: PlainNetImpactChartProps) {
  const width = props.width || 900;
  return (
    <ImpactChartContextProvider {...{ ...props, width }}>
      <NetImpactChartMain />
    </ImpactChartContextProvider>
  );
}

export const NetImpactChart = responsive(Wrapped);
